pageDiv<template>
  <div class="pageDiv">
        <v-card class="main-card">
            <v-card-title>2025 Red River Rivalry Agreement: DFWVGA (Home) & OKAGA (Away)</v-card-title><br><br>

            <span class="label14">Local and USGA Rules</span>
            <v-card-text>
                Local and USGA Rules of Golf govern all play. Clearly written rulings for the course including local rules, OB, hazards (all wooded tree lines will be played as lateral hazard for lost balls) etc., by the visiting/away team one month (July 1) before Red River Rivalry Cup event and agreed by both captains.
            </v-card-text>

            <br>
            <span class="label14">Scoring</span>
            <v-card-text>
                Each match score will be calculated pursuant to USGA rule 2, which governs Match play. The winner of each match will receive 1 point. The losing side will receive 0 points. In the event the match ends in a tie, each side will receive a half of a point. If the Red River Rivalry Cup event ends in a tie, the defending champion retains the cup.
            </v-card-text>

            <br>
            <span class="label14">Number of players:</span>
            <v-card-text>
                <ul>
                    <li>24 players from each club</li>
                </ul>
            </v-card-text>

            <br>
            <span class="label14">Clubs Shared Cost:</span>
            <v-card-text>
                The hosting (home) club must provide estimates and itemize cost one month before the Red River Rivalry Cup event date. Receipts must be made available for all costs. The cost of the event will be split evenly between the two clubs.
                <ul>
                    <li>Green fees for tournament play - 2 rounds on Saturday</li>
                    <li>Lunch between golf rounds</li>
                </ul>
            </v-card-text>

            <br>
            <span class="label14">Location:</span>
            <v-card-text>
                WinStar Casino, Chickasaw Pointe, or a course agreed upon by both clubs.
            </v-card-text>

            <br>
            <span class="label14">Tournament purse:</span>
            <v-card-text>
                The tournament purse will be $50 from each player, the winning team receives the total purse to disburse to their players.
            </v-card-text>

            <br>
            <span class="label14">Match play formats:</span>
            <v-card-text>
                <li>Round 1: 2-man best ball match play </li>
                <li>Round 2: Individual match play </li>
            </v-card-text>

            <br>
            <span class="label14">Rules of Red River Rivalry Cup:</span>
            <v-card-text>
                <ul>
                    <li><b>Injuries:</b> If a player declares an injury in the middle of an individual/singles match, he or she will forfeit and the opposing team will earn a full point for that match. In case of team/2 man best ball match, his/her partner may proceed to play the rest of the match against the opposing team by themself.</li>
                    <li>Matchups/Pairings for matches will be disclosed publicly to both teams on the Friday night before the event.</li>
                    <li>No Substitution after pairings announced.</li>
                    <li>The hosting/home club will select tee box and yardage, fully disclosed 1 month prior to the Red River Rivalry Cup event (July 1).</li>
                    <li>All players shall tee off from the same tee box.</li>
                    <li>Rangefinders with slope and golf gps apps are allowed during play.</li>
                    <li>Final list of 24 player rosters must be delivered to each other team 7 days prior to the Red River Rivalry Cup event.</li>
                    <li>Last minute substitution will require approval from both DFWVGA and OKAGA captains.</li>
                    <li>Host/Home and Visitor/Away teams alternate every year.</li>
                </ul>
            </v-card-text>

            <br>
            <span class="label14">Ryder Cup or President Cup style of match pairing:</span>
            <v-card-text>
                <ul>
                    <li>
                        Hosting/home club must deliver 2-man lineups and list of individuals for singles play, 4 days prior to the Red River Rivalry Cup event of each year.
                    </li>
                    <li>
                        Visiting/away club must then disclose 2-man lineups and individuals for singles play, matching up against home clubs lineup, 1 day prior to the Red River Rivalry Cup event of each year.
                    </li>
                </ul>

            </v-card-text>

            <br>
            <span class="label14">Other Requirements and Rules:</span>
            <v-card-text>
                <ul>
                    <li>Participants must be of only Asian ethnicity.</li>
                    <li>No active Professional or active collegiate golfer can participate.</li>
                    <li>Participants must be a member of either DFWVGA or OKAGA.</li>
                    <li>Each club will establish its own qualification requirements. Minimum requirement, each player must have participated in at least 2 tournaments in that year for each respective club.</li>
                    <li>It is the responsibility of the hosting/home club to relate all required information above to the visiting/away club, one month before the Red River Rivalry Cup date (July 1). It is also the responsibility of the visiting/away club to inquire, if not received.</li>
                    <li>This agreement must be posted with these guidelines on each club website, for transparency for members and participants.</li>
                    <li>DFWVGA and OKAGA will jointly create a Facebook page for Red River Rivalry Cup bylaws, annual event pictures, and media.</li>
                </ul>

                <br><br>
                    *Approved by Robert Gay, President of OKAGA on 2/3/2025 <br>
                    *Approved by Vincent Tran, President of DFWVGA on 2/?
            </v-card-text>

            <br>
            <span class="label14">Cup Points Distribution</span>
            <v-card-text>
                <v-simple-table class="simple-table">
                    <tr>
                        <th width="20px">Rank</th>
                        <th>Points</th>
                    </tr>
                    <tr v-for="(point, index) in points" :key="point">
                        <td>{{index+1}}</td>
                        <td>{{point}}</td>
                    </tr>
                </v-simple-table>
            </v-card-text>
        </v-card>
  </div>
</template>

<script>
  export default {
    name: "tx_cup_qualify",
    data: () => ({
      points: [ 1000, 850, 700, 600, 500, 450, 400, 350, 300, 250, 230, 210, 190, 170, 150, 140, 130, 120, 110, 100, 95, 90, 85, 80, 78, 76, 74, 72, 70, 68, 66, 64, 62, 60, 59, 58, 57, 56, 55, 54, 53, 52, 51, 50, 49, 48, 47, 46, 45, 44, 43, 42, 41, 40, 39, 38, 37]
    })
  }
</script>

<style scoped>

    ul {
        margin-left: 12px;
        list-style-type: square;
    }

    .simple-table {
      margin-left: 60px;
      width: 200px !important;
    }

    @media (min-width: 768px) {

    }
</style>
